import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Apollo } from 'apollo-angular';
import { GET_USER_FAVOURITES_QUERY, GET_USER_ORDERS_QUERY } from './profile.query';
import { CookieService } from 'ngx-cookie-service';
import { BaseService, LanguageService } from 'imakeapp-shared';


@Injectable()
export class MyAccountService extends BaseService {


  constructor(
    private http: HttpClient,
    private apollo: Apollo,
    private cookie_s: CookieService,
    public override language_s: LanguageService
  ) {
    super(language_s);
  }

  getUserOrders(user_id: number)
  {



    return this.apollo.watchQuery({
      query: GET_USER_ORDERS_QUERY(user_id, this.lang),
      fetchPolicy: 'no-cache'
    }).valueChanges;

  }


  getUserFavourites(user_id: number)
  {

    ;

    return this.apollo.watchQuery({
      query: GET_USER_FAVOURITES_QUERY(user_id, this.lang),
      fetchPolicy: 'no-cache'
    }).valueChanges;

  }


  add_new_user_address(address_data: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/Address/UsersAddress/add`, address_data);
  }

  edit_new_user_address(address_id: number, address_data: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/Address/edit/${address_id}`, address_data);
  }

  get_user_addresses()
  {
    return this.http.get(`${environment.ApiEndPoint2}/Address/UsersAddress`);
  }



  delete_user_address(address_id: any)
  {
    return this.http.get(`${environment.ApiEndPoint2}/Address/delete/${address_id}`);
  }


  edit_user(data: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/users/edituser`, data);
  }

  send_forget_password_email(body: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/forgotPassword`, body);
  }

  send_changed_password_request(body: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/resetPassword`, body);
  }

  send_user_order_rating(body: any)
  {
    return this.http.post(`${environment.ApiEndPoint2}/orders/rate`, body);
  }






    getUserPoints()
    {
      return this.http.post(`${environment.ApiEndPoint2}/points/getUserPoints`, {} );
    }

    getWallets()
    {
      return this.http.get( `${environment.ApiEndPoint2}/wallets/GetWalletForUserMobile` );
    }

    getUserCreditMobile()
    {
      return this.http.get( `${environment.ApiEndPoint2}/wallets/GetUserCreditMobile` );
    }


    get_Wallet_balance()
    {
      return this.http.get( `${environment.ApiEndPoint2}/wallets/GetUserCreditMobile` );
    }



    cancel_order_by_user(order_id: number) {
      return this.http.post(`${environment.ApiEndPoint2}/orders/editfromDashboard/${order_id}`, {
        order_status_id: 7,
      });
    }





}
